import * as React from 'react'

export interface FeaturedImagesDialogContextModel {
  isOpen: boolean
  openDialog: (imageId: string | null | undefined, imageIndex: number, userId?: string) => void
  closeDialog: () => void
  userId: string | null
  imageId: string | null
  imageIndex: number
}

const FeaturedImagesDialogContext = React.createContext<FeaturedImagesDialogContextModel>(null!)

export const FeaturedImagesDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [userId, setUserId] = React.useState<string | null>(null)
  const [imageIndex, setImageIndex] = React.useState<number>(0)
  const [imageId, setImageId] = React.useState<string | null>(null)

  const openDialog = (
    imageId: string | null | undefined,
    imageIndex: number,
    targetUserId?: string,
  ) => {
    setUserId(targetUserId || null)
    setImageIndex(imageIndex)
    setImageId(imageId || null)
    setIsOpen(true)
  }

  const closeDialog = () => {
    setIsOpen(false)
    setUserId(null)
    setImageIndex(0)
    setImageId(null)
  }

  return (
    <FeaturedImagesDialogContext.Provider
      value={{ isOpen, openDialog, closeDialog, userId, imageIndex, imageId }}
    >
      {children}
    </FeaturedImagesDialogContext.Provider>
  )
}

export const useFeaturedImagesDialog = () => {
  const context = React.useContext(FeaturedImagesDialogContext)

  if (context === undefined) {
    throw new Error('useFeaturedImagesDialog must be used within a FeaturedImagesDialogProvider')
  }
  return context
}
